/**
 * Injects the theme custom properties (dark mode, KAN-304 step 1).
 *
 * ONE `<style id="cvx-theme-vars">` in <head>: Light on `:root`, Graphite on `:root[data-theme="dark"]`
 * (which also flips `color-scheme`, so native controls/scrollbars follow). `buildThemeCss` is pure so it is
 * unit-testable; call `applyThemeVars()` before the first render so no frame paints without the variables.
 */

import { LIGHT, GRAPHITE } from './themePalettes';
import { buildContrastCss } from './accessibilityThemeVars';

export const THEME_STYLE_ID = 'cvx-theme-vars';

const declarations = (palette) => Object.entries(palette).map(([name, value]) => `${name}:${value};`).join('');

/** The CSS text: `:root{…LIGHT; color-scheme:light}` + `:root[data-theme="dark"]{…GRAPHITE; color-scheme:dark}`. */
export function buildThemeCss(light = LIGHT, graphite = GRAPHITE) {
  // --crewvex-ai-glow scales every AI brand-blue glow/shadow: full in Light, off in Graphite (no glows).
  // --cvx-auth-disabled-opacity dims a disabled pre-auth button: a light button at 0.45 reads muddy on Graphite.
  return `:root{${declarations(light)}--crewvex-ai-glow:1;--cvx-auth-disabled-opacity:0.45;color-scheme:light;}\n:root[data-theme="dark"]{${declarations(graphite)}--crewvex-ai-glow:0;--cvx-auth-disabled-opacity:0.3;color-scheme:dark;}\n${buildContrastCss()}`;
}

/** Inserts (or refreshes) the single theme <style> element. Safe to call twice. */
export function applyThemeVars(doc = typeof document !== 'undefined' ? document : null) {
  if (!doc || !doc.head) return null;
  let el = doc.getElementById(THEME_STYLE_ID);
  if (!el) {
    el = doc.createElement('style');
    el.id = THEME_STYLE_ID;
    doc.head.insertBefore(el, doc.head.firstChild);
  }
  el.textContent = buildThemeCss();
  return el;
}
